import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const t = i((o, r) => /* @__PURE__ */ e.jsx(
  s,
  {
    ref: r,
    ...o,
    image: (l) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m15.957 3.957-9.75 9.75a1 1 0 0 1-1.414 0l-4.75-4.75 1.414-1.414L5.5 11.586l9.043-9.043z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "CheckmarkIcon";
export {
  t as CheckmarkIcon,
  t as default
};
//# sourceMappingURL=index.js.map
